export const LOCAL_STORAGE_KEYS = {
  REFRESH_TOKEN: "refreshToken",
  AUTH_TOKEN: "authToken",
  USER_LOCALE: "userLocale",
  TOKEN_EXPIRE_LEFT: "tokenExpireLeft",
  SIGNED_USER: "signedUser",
};
